import React from 'react';
import { Button } from './ui/Button';
export function MakeItYours() {
  const scrollToBooking = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#FFC4D0] py-20 px-4 md:px-8" data-id="element-112">
      <div className="container mx-auto" data-id="element-113">
        <div className="flex flex-col md:flex-row items-center gap-16" data-id="element-114">
          <div className="md:w-1/2 order-2 md:order-1" data-id="element-115">
            <div className="relative" data-id="element-116">
              <img src="https://cdn.magicpatterns.com/uploads/5wDrsLUySaQra9wBq6KeWe/pasted-image.jpg" alt="Black phone with plaque" className="rounded-2xl shadow-xl w-full h-auto" data-id="element-117" />
              <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-lg max-w-xs hidden md:block" data-id="element-118">
                <p className="font-['Caveat'] text-2xl mb-2" data-id="element-119">
                  "The custom plaque was perfect!"
                </p>
                <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-120">
                  - Sarah & Mike
                </p>
              </div>
            </div>
          </div>

          <div className="md:w-1/2 order-1 md:order-2" data-id="element-121">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 text-[#1a1a1a]" data-id="element-122">
              Make it Yours
            </h2>
            <p className="text-lg text-gray-800 mb-8" data-id="element-123">
              Choose from our range of phone colors or add custom plaques to
              match your wedding theme perfectly.
            </p>

            <div className="space-y-6 mb-8" data-id="element-124">
              <div className="bg-white/40 p-6 rounded-xl" data-id="element-125">
                <h3 className="text-2xl font-bold mb-2 font-['Caveat']" data-id="element-126">
                  Name Plaque
                </h3>
                <p className="text-gray-700" data-id="element-127">
                  Add your names and wedding date with a custom plaque.
                </p>
              </div>

              <div className="bg-white/40 p-6 rounded-xl" data-id="element-128">
                <h3 className="text-2xl font-bold mb-2 font-['Caveat']" data-id="element-129">
                  Custom Greeting
                </h3>
                <p className="text-gray-700" data-id="element-130">
                  Pre-record a message for your guests to hear when they pick
                  up.
                </p>
              </div>
            </div>

            <Button variant="black" onClick={scrollToBooking} data-id="element-131">
              View Customization Options
            </Button>
          </div>
        </div>
      </div>
    </section>;
}